import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition, SizeProp } from '@fortawesome/fontawesome-svg-core';
import { COLORS } from '../settings/variables/Colors';
import { SPACERS } from '../settings/variables/Spacers';

export interface TrueImpactAlertIconProps {
  icon: IconDefinition;
  iconSize?: SizeProp;
  color?: keyof typeof COLORS;
  backgroundColor?: keyof typeof COLORS;
  shadowOpacity?: number;
  className?: string;
}

const StyledCircle = styled.div<{
  $color: keyof typeof COLORS;
  $backgroundColor: keyof typeof COLORS;
  $shadowOpacity: number;
}>`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $backgroundColor }) => COLORS[$backgroundColor]};
  color: ${({ $color }) => COLORS[$color]};
  box-shadow: 0 2px 8px rgba(0, 0, 0, ${({ $shadowOpacity }) => $shadowOpacity});
  margin-bottom: ${SPACERS.small};
`;

const TrueImpactAlertIcon: React.FC<TrueImpactAlertIconProps> = ({
  icon,
  iconSize = '2x',
  color = 'ctaPrimary',
  backgroundColor = 'grayLightest',
  shadowOpacity = 0.06,
  className,
}) => {
  return (
    <StyledCircle
      $color={color}
      $backgroundColor={backgroundColor}
      $shadowOpacity={shadowOpacity}
      className={className}
    >
      <FontAwesomeIcon icon={icon} size={iconSize} />
    </StyledCircle>
  );
};

export default TrueImpactAlertIcon;
